// 返回秒级时间戳
export function getSecondLevelTimestamp(val) {
  if (!val) {
    return 0
  }
  if (String(val).length === 10) {
    return val
  } else if (String(val).length === 13) {
    return Math.floor(val / 1000)
  }
}
